module.exports = __webpack_public_path__ + "static/img/files-and-folders.84ee2744.svg";